<template>
  <v-dialog
    v-model="isVisible"
    max-width="500"
    :persistent="isLoading"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        outlined
        small
        color="secondary"
      >
        Réinscrire
      </v-btn>
    </template>

    <v-card>
      <v-toolbar
        color="secondary"
        dark
      >
        <v-btn
          @click="isVisible = false"
          icon
          :disabled="isLoading"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-toolbar-title>Réinscrire les étudiants</v-toolbar-title>
      </v-toolbar>

      <v-card-text class="pt-5">
        <div>
          Cette fonctionnalité a été conçue pour réinscrire automatiquement les étudiants sur
          base de leur PAE. Ils seront automatiquement réinscrits dans les cours correspondants sur
          la plateforme Moodle. L'opération peut prendre quelques minutes.
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn
          text
          block
          :loading="isLoading"
          color="secondary"
          @click="ReRegisterCursus"
        >
          Réinscrire
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'RegistrationCursusDialog',

  props: {
    cursus: Object,
  },

  data: () => ({
    isVisible: false,
    isLoading: false,
  }),

  methods: {
    ...mapMutations({ showNotification: 'SET_NOTIFICATION' }),

    async ReRegisterCursus() {
      try {
        this.isLoading = true;
        const data = new FormData();
        data.append('idnumber', this.cursus.id_number);
        await this.$http.post('management/registration_course.php', data);
        this.showNotification({
          isVisible: true,
          text: 'Opération réussie',
          color: 'success',
        });
        this.isVisible = false;
      } catch (error) {
        this.showNotification({
          isVisible: true,
          text: 'Une erreur est survenue, réessayez',
          color: 'error',
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
